"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWithdrawFromTreasuryInstruction = void 0;
const splToken = __importStar(require("@solana/spl-token"));
const beet = __importStar(require("@metaplex-foundation/beet"));
const web3 = __importStar(require("@solana/web3.js"));
const withdrawFromTreasuryStruct = new beet.BeetArgsStruct([
    ['instructionDiscriminator', beet.uniformFixedSizeArray(beet.u8, 8)],
    ['amount', beet.u64],
], 'WithdrawFromTreasuryInstructionArgs');
const withdrawFromTreasuryInstructionDiscriminator = [0, 164, 86, 76, 56, 72, 12, 170];
function createWithdrawFromTreasuryInstruction(accounts, args) {
    const { treasuryMint, authority, treasuryWithdrawalDestination, auctionHouseTreasury, auctionHouse, } = accounts;
    const [data] = withdrawFromTreasuryStruct.serialize({
        instructionDiscriminator: withdrawFromTreasuryInstructionDiscriminator,
        ...args,
    });
    const keys = [
        {
            pubkey: treasuryMint,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: authority,
            isWritable: false,
            isSigner: true,
        },
        {
            pubkey: treasuryWithdrawalDestination,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: auctionHouseTreasury,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: auctionHouse,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: splToken.TOKEN_PROGRAM_ID,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false,
        },
    ];
    const ix = new web3.TransactionInstruction({
        programId: new web3.PublicKey('hausS13jsjafwWwGqZTUQRmWyvyxn9EQpqMwV1PBBmk'),
        keys,
        data,
    });
    return ix;
}
exports.createWithdrawFromTreasuryInstruction = createWithdrawFromTreasuryInstruction;
//# sourceMappingURL=withdrawFromTreasury.js.map